export const Administrator = "Administrator";
export const GlobalCoordinator = "GlobalCoordinator";
export const TechnicalAdvisor = "TechnicalAdvisor";
export const DataConsumer = "DataConsumer";
export const Manager = "Manager";
export const Supervisor = "Supervisor";
export const Coordinator = "Coordinator";
export const HeadSupervisor = "HeadSupervisor";
